import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import {
    AppSelectors,
} from 'app/shared/selectors';

import PropertiesConstants from 'app/shared/constants/PropertiesConstants';

import PropertyCardSkeleton from 'app/shared/components/skeletons/PropertyCardSkeleton';
import PropertyRowSkeleton from 'app/shared/components/skeletons/PropertyRowSkeleton';

import Bone from 'app/shared/components/Bone';

import { Table } from '@zillow/constellation';

import { Container, Row } from '@zillow/zrs-comet';

import { StyledTableContainer } from 'app/shared/components/properties/PropertiesViewList/StyledComponents';

import { StyledCol } from './StyledComponents';

const propTypes = {
    viewType: PropTypes.string,
};

const defaultProps = {
    viewType: PropertiesConstants.PROPERTIES_VIEW_TYPE.GRID,
};

const PropertiesPageSkeleton = ({ viewType }) => {
    const isScreenTabletOrDesktop = useSelector(state => AppSelectors.makeIsScreenTabletOrDesktop(state));
    const isScreenMD = useSelector(state => AppSelectors.makeIsScreenMD(state));
    const isEnterpriseCustomer = useSelector(state => state.user.isEnterpriseCustomer);

    const maxHeaderCells = isScreenMD ? 6 : 7;
    const headersForEnterpriseOrRegular = isEnterpriseCustomer ? maxHeaderCells : 5;
    const skeletonHeaderToShow = [...Array(isScreenTabletOrDesktop ? headersForEnterpriseOrRegular : 3)];
    const skeletonsToShow = [...Array(8)];

    return (
        <Container
            className="PropertiesPageSkeleton PropertiesPage-display-container"
            fluidMobile={true}
        >
            {viewType === PropertiesConstants.PROPERTIES_VIEW_TYPE.LIST
                ? (
                    <StyledTableContainer>
                        <Table
                            appearance="horizontal"
                            aria-label="Medium-sized grid table"
                            size="md"
                        >
                            <Table.Header>
                                <Table.Row>
                                    {skeletonHeaderToShow.map((_, idx) => (
                                        <Table.HeaderCell key={idx}>
                                            {(!isScreenTabletOrDesktop || idx !== 0) &&
                                                <Bone type="line" dark={true} />
                                            }
                                        </Table.HeaderCell>
                                    ))}
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {skeletonsToShow.map((_, idx) => <PropertyRowSkeleton key={idx} />)}
                            </Table.Body>
                        </Table>
                    </StyledTableContainer>
                ) : (
                    <Row className="PropertiesDisplay-listings">
                        {skeletonsToShow.map((_, idx) => (
                            <StyledCol
                                className="PropertiesDisplay-StyledCol"
                                xs={12}
                                lg={6}
                                xl={4}
                                key={idx}
                            >
                                <PropertyCardSkeleton />
                            </StyledCol>
                        ))}
                    </Row>
                )
            }
        </Container>
    );
};

PropertiesPageSkeleton.propTypes = propTypes;
PropertiesPageSkeleton.defaultProps = defaultProps;

export default PropertiesPageSkeleton;
